export default "__VITE_ASSET__Bzizy8tg__"